module.exports = __webpack_public_path__ + "img/permissions-success-blob.8dda2597.svg";